<template>
  <div>

    <Head :title="`${voucher.code} - show voucher`" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-600 hover:text-orange-500" href="/vouchers">Vouchers</Link> &raquo;{{ voucher.code }}:
        {{ voucher.description }}
      </h1>
      <Link v-if="voucher.status == 'Created'" class="btn-orange text-white-400 hover:text-white-600"
        :href="`/vouchers/${voucher.id}/edit`">Edit</Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <form>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
          <h1>
            <strong>Status: </strong>
            <span v-if="voucher.status === 'Declined'" class="declined"> {{ voucher.status }}</span>
            <span v-else class="approved"> {{ voucher.status }} </span>
          </h1>
        </div>
        <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
          <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
            <div class="grid grid-cols-1 gap-4 p-1">
              <div class="pt-2 p-2">
                <h1 style="font-size:20px; font-weight: bold;">
                  General Information
                </h1>
              </div>
            </div>
          </div>
          <div class="mb-4 overflow-x-auto">
            <div class="grid grid-cols-1 gap-4 pr-8 pl-2 pt-2 pb-2">
              <div class="flex flex-wrap">
                <label for="code" class="pr-6 w-1/2 lg:w-1/2"><strong>Code:</strong> {{ voucher.code }}</label>
                <label for="description" class="pr-6 w-1/2 lg:w-1/2"><strong>Description:</strong> {{
                  voucher.description }}</label>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4 pr-8 pl-2 pt-2 pb-2">
              <div class="flex flex-wrap">
                <label for="reason" class="pr-6 w-1/2 lg:w-1/2"><strong>Reason:</strong> {{ voucher.reason }}</label>
                <label for="customer" class="pr-6 w-1/2 lg:w-1/2"><strong>Customer:</strong> {{ voucher.customer
                  }}</label>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4 pr-8 pl-2 pt-2 pb-2">
              <div class="flex flex-wrap">
                <label for="channel" class="pr-6 w-1/2 lg:w-1/2"><strong>Channel:</strong> {{ voucher.channel }}</label>
                <label for="category" class="pr-6 w-1/2 lg:w-1/2"><strong>Category:</strong> {{ voucher.category
                  }}</label>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4 pr-8 pl-2 pt-2 pb-2">
              <div class="flex flex-wrap">
                <label for="value" class="pr-6 w-1/2 lg:w-1/2"><strong>Value:</strong> {{ voucher.value }}</label>
                <label for="type" class="pr-6 w-1/2 lg:w-1/2"><strong>Type:</strong> {{ voucher.type }}</label>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-4 pr-8 pl-2 pt-2 pb-2">
              <div class="flex flex-wrap">
                <label class="pr-6 w-1/2 lg:w-1/2"><strong>Date: </strong>{{ voucher.date }}</label>
              </div>
            </div>
          </div>
          <div v-show="voucher.status == 'Applied'" class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
            <div class="grid grid-cols-1 gap-4 p-1">
              <div class="pt-2 p-2">
                <h1 style="font-size:20px; font-weight: bold;">
                  Order #{{ voucher.orderObj.order_no }} - {{ voucher.orderObj.customer }}
                </h1>
              </div>
            </div>
            <div v-if="voucher.details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
              <div class="mb-4">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3">#</th>
                    <th class="pb-3 pt-3 px-3">SKU</th>
                    <th class="pb-3 pt-3 px-3">Description</th>
                    <th class="pb-3 pt-3 px-3">Quantity</th>
                    <th class="pb-3 pt-3 px-3 items-end justify-end">Unit Cost</th>
                    <th class="pb-3 pt-3 px-3 items-end justify-end">Discount</th>
                    <th class="pb-3 pt-3 px-3 items-end justify-end">Amount</th>
                  </tr>
                  <tr v-for="(item, index) in voucher.details" :key="index">
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-center px-3">{{ index + 1 }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-left px-3">{{ item.sku }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-left px-3">{{ item.description }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-center px-3">{{ item.quantity }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-end px-3 items-end justify-end">{{ item.unit_cost }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-end px-3 items-end justify-end">{{ item.discount_rate }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-end px-3 items-end justify-end">{{ item.amount }}</span>
                    </td>
                  </tr>
                  <tr v-if="voucher.orderObj.transport && voucher.orderObj.transport > 0">
                    <td class="w-px border-t pb-3 pt-3" width="2%"><span class="flex items-center px-3">
                        {{ voucher.details.length + 1 }}</span></td>
                    <td class="w-px border-t pb-3 pt-3" width="10%">
                      <span class="flex items-left px-3">{{ voucher.orderObj.transport_name }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3" width="30%">
                      <span class="flex items-left px-3">{{ voucher.orderObj.transport_description }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-center justify-center px-3">1</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3" width="5%">
                      <span class="flex items-center justify-center px-3">{{ voucher.orderObj.transport_amount }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3" width="5%">
                      <span class="flex items-center justify-center px-3">0</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-end px-3 items-end justify-end">{{ voucher.orderObj.transport_amount
                        }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
            <div class="grid grid-cols-1 gap-4 p-1">
              <div class="pt-2 p-2">
                <h1 style="font-size:20px; font-weight: bold;">
                  Transaction Logs
                </h1>
              </div>
            </div>
            <div v-if="voucher.logs.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
              <div class="mb-4">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3">#</th>
                    <th class="pb-3 pt-3 px-3">Date</th>
                    <th class="pb-3 pt-3 px-3">Status</th>
                    <th class="pb-3 pt-3 px-3">User</th>
                  </tr>
                  <tr v-for="(log, lindex) in voucher.logs" :key="lindex">
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-center px-3">{{ lindex + 1 }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-left px-3">{{ log.created_at }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-left px-3">{{ log.status }}</span>
                    </td>
                    <td class="w-px border-t pb-3 pt-3">
                      <span class="flex items-left px-3">{{ log.user }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span v-if="
            voucher.status == 'Created' && (
              user.role === 'admin' ||
              user.per_user_permissions.includes('approve_vouchers'))
          " class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5 ml-1 mr-1"
              @click="openDeclinePrompt">
              Decline
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button v-if="
              voucher.status == 'Created' && (
                user.role === 'admin' ||
                user.per_user_permissions.includes('approve_vouchers'))
            " type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1"
              @click="openApprovePrompt">
              Approve
            </button>
          </span>
        </div>
      </form>
    </div>
  </div>
  <div v-if="isApprovePrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6" style="display: inline !important; cursor: pointer;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>

              Approve Voucher: {{ voucher.code }} {{ voucher.description }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to approve the <strong>{{ voucher.code }} {{ voucher.description }}</strong>, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submit('approve')">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclineModal">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isDeclinePrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle"
        role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 20px;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6" style="display: inline !important; cursor: pointer;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>

              Decline Voucher: {{ voucher.code }} {{ voucher.description }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to decline the <strong>{{ voucher.code }} {{ voucher.description }}</strong>, do you wish to
              continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5"
                @click="submit('decline')">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                @click="closeDeclineModal">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Icon,
    Link,
  },
  layout: Layout,
  props: {
    voucher: Object,
    errors: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        id: null,
        action: null,
      }),
      isDeclinePrompt: false,
      isApprovePrompt: false,
    }
  },
  computed: {
    user() {
      return this.$inertia.page.props.auth.user
    },
  },
  methods: {
    openApprovePrompt() {
      this.isDeclinePrompt = false
      this.isApprovePrompt = true
    },
    closeApproveModal() {
      this.isDeclinePrompt = false
      this.isApprovePrompt = false
    },
    openDeclinePrompt() {
      this.isDeclinePrompt = true
      this.isApprovePrompt = false
    },
    closeDeclineModal() {
      this.isDeclinePrompt = false
      this.isApprovePrompt = false
    },
    submit(action) {
      let cancelData = {}
      cancelData._method = 'delete'
      cancelData.id = this.voucher.id
      cancelData.action = action
      this.$inertia.post(`/vouchers/${this.voucher.id}`, cancelData, {
        onSuccess: () => {
          this.isDeclinePrompt = false
          this.isApprovePrompt = false
        },
      })
    },
  },
}
</script>
<style>
.modal-wrapper h1 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}

.approved {
  color: green;
}

.declined {
  color: red;
}
</style>